
import axios from '@/assets/http';

export default {
    get(params) {
        return axios.post(`/api/v3/frontend/house/get`, params);
    },
    getInfo(params) {
        //旧接口 /api/house/getHouseInfo
        return axios.get(`/api/v3/frontend/house/info`, { params: params,
            headers: {'map-company':'baidu'}
        });
    },
    filterType(params) {
        return axios.get(`/api/house/filterType`, { params: params });
    },
    
}
